import React from 'react'
import styled from '@emotion/styled'
import { TableV2 } from 'stylist'

const TableHead = styled(TableV2.Head)`
  overflow-y: scroll;
  display: block;
`

const SamplesTableHead = ({ headerGroups }) => {
  return (
    <TableHead>
      {headerGroups.map(headerGroup => (
        <TableV2.Row {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map(column => (
            <TableV2.HeadCell
              {...column.getHeaderProps({
                isSorted: column.isSorted,
                isSortedDesc: column.isSortedDesc,
                canSort: column.canSort,
                ...column.getSortByToggleProps()
              })}
              title={column.Header}
            >
              {column.render('Header')}
            </TableV2.HeadCell>
          ))}
        </TableV2.Row>
      ))}
    </TableHead>
  )
}

export default SamplesTableHead



// WEBPACK FOOTER //
// ./src/routes/admin/SamplesTableHead.js